import { createApiAction, restApiActions } from 'redux/redux-actions';

import restApis from '../restApis';
import {
  REINVITE_MEMBER,
} from '../constants';

const reinviteMemberApi = restApis('members', 're-invite').create;

export default restApiActions('members');
export const reinviteMember = createApiAction(REINVITE_MEMBER, reinviteMemberApi);
